(function(){
  function pill(code){
    var safe=code.replace(/&/g,'&amp;').replace(/"/g,'&quot;');
    return '<span class="flex align-center gap-5 px-10 py-5 fs-small rounded" data-remove-code="'+safe+'" style="background:#e6ffe0;color:#137F24;font-weight:600;cursor:pointer;">'+
      '<svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M2 5.5L4.5 8L9 3" stroke="#137F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'+
      code.toUpperCase()+
      '<svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1 1L8 8M8 1L1 8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>'+
      '</span>';
  }

  function updatePills(discountCodes){
    var container=document.querySelector('.patoul-pills');
    if(!container)return;
    var applied=(discountCodes||[]).filter(function(d){return d.applicable!==false;});
    container.innerHTML=applied.map(function(d){return pill(d.code);}).join('');
    // Hide suggestion if code applied
    var suggestion=document.querySelector('.patoul-suggestion');
    if(suggestion)suggestion.style.display=applied.length>0?'none':'';
  }

  function updatePrices(){
    fetch('/?sections=minicart-form').then(function(r){return r.json();}).then(function(data){
      var html=data['minicart-form'];if(!html)return;
      var doc=new DOMParser().parseFromString(html,'text/html');
      ['[data-cart-subtotal]','[data-discounts]','[data-cart-subtotal-price]'].forEach(function(sel){
        var fresh=doc.querySelector(sel);
        var current=document.querySelector(sel);
        if(fresh&&current)current.innerHTML=fresh.innerHTML;
      });
    }).catch(function(){});
  }

  function applyCode(code,btn){
    if(btn){btn.disabled=true;btn.textContent='...';}
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code})})
      .then(function(r){return r.json();})
      .then(function(data){
        updatePills(data.discount_codes||[]);
        updatePrices();
        return data;
      })
      .catch(function(err){console.error(err);})
      .then(function(data){
        if(btn){btn.disabled=false;btn.textContent='Anwenden';}
        return data;
      });
  }

  // Manual form submit
  document.addEventListener('submit',function(e){
    if(!e.target.closest('#patoul-discount-widget'))return;
    e.preventDefault();e.stopPropagation();
    var widget=e.target.closest('#patoul-discount-widget');
    var input=widget.querySelector('input[name="discount"]');
    var btn=widget.querySelector('button[type="submit"]');
    var code=(input?input.value:'').trim();if(!code)return;
    applyCode(code,btn).then(function(){if(input)input.value='';});
  },true);

  // Click on suggestion chip → apply PAT20
  document.addEventListener('click',function(e){
    if(e.target.closest('.patoul-apply-suggestion')){
      var widget=e.target.closest('#patoul-discount-widget');
      var btn=widget?widget.querySelector('button[type="submit"]'):null;
      applyCode('PAT20',btn);
      return;
    }
    // Remove pill
    var p=e.target.closest('[data-remove-code]');
    if(!p||!p.closest('#patoul-discount-widget'))return;
    applyCode('',null).then(function(){
      // Show suggestion again after removal
      var suggestion=document.querySelector('.patoul-suggestion');
      if(suggestion)suggestion.style.display='';
    });
  });
})();
